<template>
  <div>
    <el-container class="p-3">
      <el-form inline>
        <el-form-item>
          <selectRoleLabel @onSelect="onSelectRole" />
        </el-form-item>

        <el-form-item v-if="showCom">
          <companySelect :id.sync="company_id" @onSelect="onSelectCompany" />
        </el-form-item>

        <el-form-item>
          <el-button
            v-if="$route.meta.action.c"
            type="primary"
            @click="
              createUserDialog = true;
              user = null;
            "
          >
            新增
          </el-button>
        </el-form-item>
      </el-form>
    </el-container>
    <el-table :data="users" style="width: 100%" stripe :row-class-name="checkSelf">
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column prop="name" label="姓名" />
      <el-table-column prop="description" label="說明" />
      <el-table-column prop="email" label="email" />
      <el-table-column label="角色">
        <template slot-scope="scope">
          <div v-if="scope.row.roles.length">
            {{ scope.row.roles[0].name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="狀態">
        <template slot-scope="scope">
          <el-switch v-if="disableSelf(scope.row)" v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="true" :inactive-value="false" @change="onSwitchChange(scope.row)" />
          <div v-else>不可用</div>
        </template>
      </el-table-column>
      <el-table-column label="動作">
        <template v-if="disableSelf(scope.row) && $route.meta.action.u" slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="
              user = scope.row;
              createUserDialog = true;
            "
            >編輯</el-button
          >
          <el-popconfirm v-if="$route.meta.action.d" title="確定刪除?" @confirm="deleteUser()">
            <el-button slot="reference" type="danger" size="small" class="ml-3" @click="user = scope.row">刪除 </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="編輯使用者" :visible.sync="createUserDialog" width="80%">
      <createUserForm
        v-if="createUserDialog"
        :user="user"
        @closeDialog="
          createUserDialog = false;
          user = null;
        "
        @success="onSelectRole(roleLabel)"
      />
      <span slot="footer" class="dialog-footer" />
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import selectRoleLabel from './components/selectRoleLabel.vue';
import { getUsers, updateUser, deleteUserV2, userStatus } from '@/api/user';
import createUserForm from './components/createUserForm.vue';
import companySelect from '@/components/select/companies.vue';
const methods = {
  ...mapMutations('variable', ['setRoleLabel']),
  checkSelf({ row, rowIndex }) {
    return this.name === row.name ? 'warning-row' : '';
  },
  async onSelectCompany() {
    this.createUserDialog = false;
    this.users = await getUsers({ company_id: this.company_id });
  },
  async init() {},
  async onSwitchChange(user) {
    try {
      const data = await userStatus({ status: user.status, id: user.id });
      this.$message({
        message: '設定成功',
        type: 'success',
      });
    } catch (error) {}
  },

  disableSelf(user) {
    if (user.name !== this.name) {
      return true;
    } else {
      return false;
    }
  },
  async deleteUser() {
    const data = await deleteUserV2(this.user.id);
    this.$message({
      message: '設定成功',
      type: 'success',
    });
    this.onSelectRole(this.roleLabel);
    this.deleteUserDialog = false;
  },
  async onSelectRole(roleLabel) {
    this.users = [];
    const company_id = roleLabel === '0' ? null : this.company_id;
    this.showCom = roleLabel !== '0';
    this.users = await getUsers({ company_id });
    this.createUserDialog = false;
  },
};
export default {
  components: {
    createUserForm,
    companySelect,
    selectRoleLabel,
  },
  data() {
    return {
      rootCompany: true,
      rootCom: '1',
      company_id: null,
      users: [],
      createUserDialog: false,
      deleteUserDialog: false,
      showCom: false,
    };
  },
  computed: {
    ...mapGetters(['name']),
    ...mapGetters('variable', ['roleLabels', 'roleLabel']),
  },
  created() {
    this.init();
  },
  methods,
};
</script>
<style>
.el-table .warning-row {
  background: rgb(230, 253, 245);
}
</style>
